import { render, staticRenderFns } from "./shortdef.vue?vue&type=template&id=2a02433b&"
import script from "./shortdef.vue?vue&type=script&lang=js&"
export * from "./shortdef.vue?vue&type=script&lang=js&"
import style0 from "./shortdef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a02433b')) {
      api.createRecord('2a02433b', component.options)
    } else {
      api.reload('2a02433b', component.options)
    }
    module.hot.accept("./shortdef.vue?vue&type=template&id=2a02433b&", function () {
      api.rerender('2a02433b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/shortdef.vue"
export default component.exports